import React from "react";
import "./AboutDetails.css";
import junk from "../../Assests/abouthomee.jpg";

export default function AboutDetails() {
  return (
    <section className="about-detail">
      <div className="about-detail__container">
        {/* Image Section */}
        <div className="about-detail__visual">
          <div className="image-wrapper">
            <img 
              src={junk}
              alt="Professional junk removal team at work"
              className="main-image"
            />
            <div className="image-overlay"></div>
            <div className="decoration-element"></div>
          </div>
        </div>

        {/* Content Section */}
        <div className="about-detail__content">
          <span className="section-tag">Our Expertise</span>
          <h2 className="section-title">
            Premium Junk Removal <span className="highlight">Services</span>
          </h2>
          
          <p className="section-description">
            We transform cluttered spaces into clean, usable areas with our 
            professional junk removal services. Our team handles everything 
            from single-item pickups to full property cleanouts with efficiency 
            and care.
          </p>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M12 3L1 9l11 6 9-4.91V17h2V9M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"/>
                </svg>
              </div>
              <h3>Full-Service Solution</h3>
              <p>From assessment to removal and disposal - we handle it all</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"/>
                </svg>
              </div>
              <h3>Transparent Pricing</h3>
              <p>No hidden fees with upfront, all-inclusive quotes</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                </svg>
              </div>
              <h3>Eco-Conscious</h3>
              <p>70%+ of items recycled or donated to local charities</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z"/>
                </svg>
              </div>
              <h3>Same-Day Service</h3>
              <p>Available for urgent removal needs in most areas</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}